import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useSearchParams } from 'react-router-dom';
import Journals from '@/routes/Journals';
import Journal from '@/routes/Journal';
import Publications from '@/routes/Publications';
import Publication from '@/routes/Publication';
import Researchers from '@/routes/Researchers';
import Researcher from '@/routes/Researcher';
import Departments from '@/routes/Departments';
import Department from '@/routes/Department';
import Search from '@/routes/Search';
import MypageMyProfile from '@/routes/MypageMyProfile';
import { getBasePath } from './wpconfig/wpconfig.runtime';

function NavigationHandler() {
	const location = useLocation();

	useEffect(() => {
		const updateActiveMenu = () => {
			const currentPath = location.pathname;
			const links = document.querySelectorAll('a.spa-link');
			const base = getBasePath(); // e.g. "/scholar2"
			
			links.forEach(link => {
				const li = link.parentElement;
				if (!li || li.tagName !== 'LI') return;

				const href = link.getAttribute('href');
				if (!href) return;

				try {
					const url = new URL(href, window.location.origin);
					const menuPath = url.pathname;
					const homeUrl = (typeof rmVars !== 'undefined' && rmVars.homeUrl) ? new URL(rmVars.homeUrl).pathname : '';
					const targetPath = homeUrl ? menuPath.replace(homeUrl, '') : menuPath;

					// location.pathname은 basename이 제외된 상태임 (e.g. "/publications/48538")
					const currentPathNormalized = currentPath.startsWith('/') ? currentPath : '/' + currentPath;
					
					const normalizedCurrentPath = currentPathNormalized.endsWith('/') ? currentPathNormalized : currentPathNormalized + '/';
					const normalizedMenuPath = targetPath.endsWith('/') ? targetPath : targetPath + '/';

					let isActive = false;
					if (targetPath === '/' || targetPath === '') {
						isActive = currentPathNormalized === '/' || currentPathNormalized === '';
					} else {
						isActive = normalizedCurrentPath.startsWith(normalizedMenuPath);
					}

					if (isActive) {
						li.classList.add('active', 'text-[#4B4DFF]');
						li.classList.remove('hover:text-[#4B4DFF]');
						// 만약 하위 a 태그에 스타일이 있다면 그것도 처리 (필요시)
					} else {
						li.classList.remove('active', 'text-[#4B4DFF]');
						li.classList.add('hover:text-[#4B4DFF]');
					}
				} catch (e) {
					// URL 파싱 실패 시 무시
				}
			});
		};

		// React Router의 이동은 microtask 이후에 완료되므로 약간의 지연을 주거나 
		// 혹은 브라우저의 URL이 업데이트된 후에 실행되도록 함
		const timer = setTimeout(updateActiveMenu, 0);
		return () => clearTimeout(timer);
	}, [location]);

	return null;
}

function WithSearchKey({ element }) {
	const { search } = useLocation();
	const El = element;
	return <El key={search} />;
}

// ✅ /journals 에서 ?id 있으면 상세로 분기
function JournalsGate() {
	const [sp] = useSearchParams();
	const id = sp.get('id');
	return id ? <WithSearchKey element={Journal} /> : <Journals />;
}

// ✅ /publications 에서 ?id 있으면 상세로 분기
function PublicationsGate() {
	const [sp] = useSearchParams();
	const id = sp.get('id');
	return id ? <WithSearchKey element={Publication} /> : <Publications />;
}

function ResearchersGate() {
	const [sp] = useSearchParams();
	const id = sp.get('id');
	return id ? <WithSearchKey element={Researcher} /> : <Researchers />;
}

function DepartmentsGate() {
	const [sp] = useSearchParams();
	const id = sp.get('id');
	return id ? <WithSearchKey element={Department} /> : <Departments />;
}

export default function WebApp() {
	const basename = getBasePath(); // '/scholar' 권장
	return (
		<>
			<BrowserRouter basename={basename}>
				<NavigationHandler />
				<Routes>
					<Route path="journals" element={<JournalsGate />} />
					<Route path="journals/:id" element={<Journal />} />
					<Route path="publications" element={<PublicationsGate />} />
					<Route path="publications/:id" element={<Publication />} />
					<Route path="researchers" element={<ResearchersGate />} />
					<Route path="researchers/:id" element={<Researcher />} />

					<Route path="departments" element={<DepartmentsGate />} />
					<Route path="departments/:id" element={<Department />} />

					<Route path="search" element={<Search />} />
					<Route path="mypage" element={<MypageMyProfile />} />
					<Route path="mypage/edit/*" element={<MypageMyProfile />} />
				</Routes>
			</BrowserRouter>
		</>
	);
}
